module.exports = __webpack_public_path__ + "img/x.d3419daa.svg";